/** Available on every hostname, including production. */
export function isRelayOnlyRequested(search = window.location.search): boolean {
    return new URLSearchParams(search).get('relay_only') === '1';
}
